import { VerdictBadge } from '@/components/atoms/VerdictBadge';

import type { RubricVerdictCardProps } from './RubricVerdictCard.types';

export const RubricVerdictCard = ({ verdict }: RubricVerdictCardProps) => (
	<article className="flex flex-col gap-2xs rounded-md border border-subtle bg-white px-md py-sm">
		<header className="flex items-center justify-between">
			<h3 className="text-[12px] font-semibold text-default">{verdict.judgeName}</h3>
			<VerdictBadge verdict={verdict} />
		</header>
		<p className="text-[12px] leading-5 text-subtle">{verdict.reasoning}</p>
	</article>
);
